export default "__VITE_PUBLIC_ASSET__8703d350__"